export default __webpack_public_path__ + "static/media/complete_api.b13723b2.png";